import { useTranslation } from 'react-i18next'
import LanguageSwitcher from './LanguageSwitcher'

interface HeaderProps {
  scrollY: number
}

const Header = ({ scrollY }: HeaderProps) => {
  const { t } = useTranslation()
  const isScrolled = scrollY > 50

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        isScrolled
          ? 'bg-crafter-base/90 backdrop-blur-md border-b border-crafter-accent/10'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 relative">
              <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16 4L28 10V22L16 28L4 22V10L16 4Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  className="text-crafter-accent"
                />
                <circle cx="16" cy="16" r="4" className="fill-crafter-accent" />
                <path
                  d="M16 4V28M4 10L28 22M28 10L4 22"
                  stroke="currentColor"
                  strokeWidth="0.5"
                  className="text-crafter-accent/30"
                />
              </svg>
            </div>
            <span className="font-sans font-semibold text-lg tracking-tight">
              {t('brandName')}
            </span>
          </div>

          {/* Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <a
              href="#features"
              className="font-mono text-sm text-crafter-textDim hover:text-crafter-accent transition-colors"
            >
              {t('nav.features')}
            </a>
            <a
              href="#interface"
              className="font-mono text-sm text-crafter-textDim hover:text-crafter-accent transition-colors"
            >
              {t('nav.interface')}
            </a>
            <a
              href="#workflow"
              className="font-mono text-sm text-crafter-textDim hover:text-crafter-accent transition-colors"
            >
              {t('nav.workflow')}
            </a>
            <LanguageSwitcher />
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center gap-4">
            <LanguageSwitcher />
            <button className="p-2 text-crafter-text">
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
